import { Injectable } from "@angular/core"
import { AppService } from "src/app/core/services/app.service"
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"
import { environment } from "../../../../environments/environment"

@Injectable({
  providedIn: "root",
})
export class SchoolAdminDashboardService {
  private get_segments: string
  private get_users: string
  private get_users_per_application: string
  private get_digital_usages: string
  private get_cached_users_per_application: string
  private get_cached_segments_and_profiles: string
  private get_cached_digital_usages: string

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointDashboard.url)
  }

  private buildUrls(dashboardUrl: string) {
    this.get_segments =
      dashboardUrl + environment.endpointDashboard.routes.get_segments
    this.get_users =
      dashboardUrl + environment.endpointDashboard.routes.get_users
    this.get_users_per_application =
      dashboardUrl +
      environment.endpointDashboard.routes.get_users_per_application
    this.get_digital_usages =
      dashboardUrl + environment.endpointDashboard.routes.get_digital_usages
    this.get_cached_users_per_application =
      dashboardUrl +
      environment.endpointDashboard.routes.get_cached_users_per_aplications
    this.get_cached_segments_and_profiles =
      dashboardUrl +
      environment.endpointDashboard.routes.get_cached_segments_and_profiles
    this.get_cached_digital_usages =
      dashboardUrl +
      environment.endpointDashboard.routes.get_cached_digital_usages
  }

  getSegments(schoolIds: string) {
    const params = new HttpParams().set("schoolIds", schoolIds)

    return this.httpClient.get(this.get_segments, { params })
  }

  getUsers(schoolIds: string) {
    const params = new HttpParams().set("schoolIds", schoolIds)

    return this.httpClient.get(this.get_users, { params })
  }

  getUsersPerApplications(schoolIds: string) {
    let params = new HttpParams().set("schoolIds", schoolIds)

    return this.httpClient.get(this.get_users_per_application, { params })
  }

  getDigitalUsages(schoolId: string, segmentId: string) {
    const params = new HttpParams()
      .set("schoolId", schoolId)
      .set("segmentId", segmentId)

    return this.httpClient.get(this.get_digital_usages, { params })
  }

  getCachedUsersPerApplications(schoolId: string) {
    let params = new HttpParams().set("schoolId", schoolId)

    return this.httpClient.get(this.get_cached_users_per_application, {
      params,
    })
  }

  getCachedSegmentsAndProfiles(schoolId: string) {
    let params = new HttpParams().set("schoolId", schoolId)

    return this.httpClient.get(this.get_cached_segments_and_profiles, {
      params,
    })
  }

  getCachedDigitalUsages(
    schoolId: string,
    segmentId: string,
    profileId?: string
  ) {
    let params = new HttpParams()
      .set("schoolId", schoolId)
      .set("segmentIds", segmentId)

    if (profileId) {
      params = params.set("profileIds", profileId)
    }

    return this.httpClient.get(this.get_cached_digital_usages, { params })
  }
}
